import ShareMsgBase from './A_G.ShareMsgBase';

class MsgTreasureHuntInvite extends ShareMsgBase {
  /**
   * The message that gets sent when you invite through treasure hunt
   * @param {string} user1
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    if (!user1.avatar) user1.avatar = user1.image;
    this.avatar1 = this._addExtImage(250, 78, user1.avatar, 0, 190);
    this.bg = this._addExtImage(0, 0, 'img/treasure_hunt_friend.png', 0);
  }
}

G.MsgTreasureHuntInvite = MsgTreasureHuntInvite;
